export default __webpack_public_path__ + "static/media/saml.5b1e13611a03c5436f4221e85c579032.svg";